// services/AuditLogService.js
import api from "../utils/axios";
import { ENDPOINTS } from "../utils/endpoints";

export function getAuditLogs(params = {}) {
    return api.get(ENDPOINTS.AUDIT_LOGS.BASE, { params });
}
